"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeTableSchema = void 0;
exports.TimeTableSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/time-table.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TimeTable",
    "description": "Add a time-table e.g. for an event",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:time-table"
            ]
        },
        "timeTableEntries": {
            "type": "array",
            "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                    "description": {
                        "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
                    },
                    "endDateTime": {
                        "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json"
                    },
                    "startDateTime": {
                        "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json"
                    },
                    "title": {
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    }
                },
                "required": [
                    "description",
                    "title"
                ]
            }
        }
    },
    "required": [
        "timeTableEntries",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZS10YWJsZS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL3RpbWUtdGFibGUuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZUFBZSxHQUFHO0lBQzdCLEtBQUssRUFBRSxtRUFBbUU7SUFDMUUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsV0FBVztJQUNwQixhQUFhLEVBQUUsb0NBQW9DO0lBQ25ELE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHVCQUF1QjthQUN4QjtTQUNGO1FBQ0Qsa0JBQWtCLEVBQUU7WUFDbEIsTUFBTSxFQUFFLE9BQU87WUFDZixPQUFPLEVBQUU7Z0JBQ1AsTUFBTSxFQUFFLFFBQVE7Z0JBQ2hCLHNCQUFzQixFQUFFLEtBQUs7Z0JBQzdCLFlBQVksRUFBRTtvQkFDWixhQUFhLEVBQUU7d0JBQ2IsTUFBTSxFQUFFLG1GQUFtRjtxQkFDNUY7b0JBQ0QsYUFBYSxFQUFFO3dCQUNiLE1BQU0sRUFBRSxrRUFBa0U7cUJBQzNFO29CQUNELGVBQWUsRUFBRTt3QkFDZixNQUFNLEVBQUUsa0VBQWtFO3FCQUMzRTtvQkFDRCxPQUFPLEVBQUU7d0JBQ1AsTUFBTSxFQUFFLDZEQUE2RDtxQkFDdEU7aUJBQ0Y7Z0JBQ0QsVUFBVSxFQUFFO29CQUNWLGFBQWE7b0JBQ2IsT0FBTztpQkFDUjthQUNGO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLGtCQUFrQjtRQUNsQixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=